.quickSetupPrompt {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	background-color: #7a61cf;
	border-radius: 8px;
	padding: 12px;
	gap: 10px;
	box-sizing: border-box;
	min-width: 300px;

	& .stepChip {
		min-width: fit-content;

		& :global(.MuiChip-label) {
			font-size: 12px;
			font-weight: 500;
			color: #291375;
		}
	}

	& .title {
		color: #ffffff;
		font-size: 15px;
		line-height: 1.5;
		font-weight: 600;
	}

	& .description {
		color: #ffffff;
		font-size: 14px;
		line-height: 1.6;
		font-weight: 400;
	}
}
